// extracted by mini-css-extract-plugin
export default {"container":"Devices_container__rs1IF","greeting":"Devices_greeting__PGNda","footer":"Devices_footer__91qcz"};